var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 130,
    viewBox: "0 0 128 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24118 3793)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 130,
    transform: "translate(-24118 -3793)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24279.963 -3841.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.88,118.823a21.645,21.645,0,0,1-19.253.993,39.377,39.377,0,0,0-29.433-.041,40.225,40.225,0,0,1-28.89,0,39.426,39.426,0,0,0-29.433.041,21.678,21.678,0,0,1-19.253-.993l3.369-5.694a15.07,15.07,0,0,0,13.313.584V57.55h21.035v5.4a20.681,20.681,0,0,1,2.181-2.058,21.7,21.7,0,0,1,30.57,3.031,22.138,22.138,0,0,1,39.1,13.129v36.684a15.142,15.142,0,0,0,13.314-.6ZM215.421,114V80.418a7.494,7.494,0,0,0-14.87-1.208v31.061A60.207,60.207,0,0,1,215.421,114m35.537-3.933V80.029a7.458,7.458,0,0,0-14.88.389v33.816a70.939,70.939,0,0,1,14.88-4.168m18.874,32.147a18.568,18.568,0,0,0-8.777-15.372,20.191,20.191,0,0,0-25.234,1.342,20.764,20.764,0,0,0-7.046,14.706,34.5,34.5,0,0,0,1.915,16.8,20.064,20.064,0,0,0,11.716,10.6,18.538,18.538,0,0,0,15.433-.952,20.932,20.932,0,0,0,11.91-17.185H256.774a11.117,11.117,0,0,1-4.127,6.093c-4.148,2.755-9.022.01-10.886-6.093s0-13.283,4.137-16.027c4.158-2.745,9.022-.01,10.886,6.093ZM195.778,157.37a3.88,3.88,0,0,0,2.4,3.451,9.644,9.644,0,0,0,7.322,0,3.662,3.662,0,0,0,.225-6.79,14.952,14.952,0,0,0-3.267-1.157c-1.464-.328-2.939-.655-4.414-.952-.768-.154-1.526-.277-2.3-.389a22.1,22.1,0,0,1-11.665-5.295,13.707,13.707,0,0,1-1.936-3.1,13.322,13.322,0,0,1,6.7-17.584,32.279,32.279,0,0,1,25.634-.266,12.482,12.482,0,0,1,8.316,11.593H208.713a4.941,4.941,0,0,0-4.189-3.922,8.1,8.1,0,0,0-5.418.543,4.008,4.008,0,0,0-2.2,4.987,6.807,6.807,0,0,0,4.957,3.349,67.376,67.376,0,0,1,11.685,2.7,11.681,11.681,0,0,1,4.5,1.946,13.158,13.158,0,0,1-1.219,21.64,32.641,32.641,0,0,1-24.415,1.986,12.9,12.9,0,0,1-10.528-12.73Zm0,0",
    transform: "translate(0 0)",
    fill: "#141b33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsc);
export default __webpack_public_path__ + "static/media/msc.4621893278ce6591ab964113a6d7171d.svg";
export { ForwardRef as ReactComponent };